import { CustomInputAttributes } from 'src/pages/AssortmentBuild/StyleEdit/StyleEdit.types';
import {
  TextValidationEditor,
  viewDefnWhitelistToNarrowedCharacterWhitelist,
} from 'src/pages/AssortmentBuild/StyleEdit/StyleEditSection/Editors/TextValidationEditor';
import { isNumberValid } from 'src/pages/AssortmentBuild/StyleEdit/StyleEditSection/Editors/IntegerEditor/IntegerEditor.utils';

export const cleanPastedValue = (
  value: string,
  inputType?: string,
  inputParams?: CustomInputAttributes,
  previousValue?: string | number,
): any => {
  switch (inputType) {
    case 'integer': {
      const cleanedValue = value.replace(/[^0-9.]/g, '');
      let parsedValue = parseFloat(cleanedValue);

      if (isNaN(parsedValue)) {
        return null;
      }

      if (value.trim().endsWith('%') || inputParams?.percent) {
        parsedValue = parsedValue / 100;
      }

      return isNumberValid(parsedValue, inputParams) ? parsedValue : previousValue;
    }
    case 'textValidator': {
      const whitelist = inputParams?.whitelist
        ? viewDefnWhitelistToNarrowedCharacterWhitelist(inputParams.whitelist)
        : undefined;
      const maxLen = inputParams?.maxLength;

      return TextValidationEditor.validateText(String(value ?? ''), whitelist as any, maxLen).trim();
    }
    default:
      return value;
  }
};
